import RestClient from '../../../../api/axiosInterceptor';
import { pharmacyProfileActions } from '../../../actions/user/pharmacy/Profile/profile';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });
    const response = await apiCall();
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : error.message;
    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
    return { error: errorMessage };
  }
};

export const updatePharmacyProfile = (user, formData) => {
  return createAsyncAction(
    pharmacyProfileActions.UPDATE_PHARMACY,
    () => {
      return RestClient.patch('/pharmacy/profile/', formData, {
        headers: {
          Authorization: `Basic ${user}`,
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      });
    }
  );
};

export const fetchPharmacyProfile = () => async (dispatch) => {
  try {
    dispatch({ type: pharmacyProfileActions.FETCH_PHARMACY.REQUEST });
    const response = await RestClient.get('/pharmacy/profile/', {
      withCredentials: true
    });
    dispatch({
      type: pharmacyProfileActions.FETCH_PHARMACY.SUCCESS,
      payload: response.data
    });
    return { payload: response.data }; // Explicitly return payload
  } catch (error) {
    console.error('Fetch Pharmacy Profile Error:', error);
    const errorMessage = error.response?.data?.error || error.message;
    dispatch({
      type: pharmacyProfileActions.FETCH_PHARMACY.FAILURE,
      payload: errorMessage
    });
    toast.error(errorMessage);
    return { error: errorMessage };
  }
};
